import { DROPDOWN_GROUP_ACTIONS_TYPE } from "../actions-type";

const initialState = {
  selectedGroup: "",
  GroupId: "",
  groupStatus: "current",
};

export const dropdownGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    case DROPDOWN_GROUP_ACTIONS_TYPE.SELECT_GROUP:
      return {
        ...state,
        selectedGroup: action.payload,
      };
    case DROPDOWN_GROUP_ACTIONS_TYPE.SELECT_GROUP_STATUS:
      return {
        ...state,
        groupStatus: action.payload,
      };
    case DROPDOWN_GROUP_ACTIONS_TYPE.CLEAR_GROUP:
      return initialState;
    case DROPDOWN_GROUP_ACTIONS_TYPE.SE:
      return {
        GroupId: "",
      };
    default:
      return state;
  }
};
